/**
 * `/auth/signed-out` — the confirmation landing after an explicit sign-out.
 * Offers a route back to centralized login.
 */
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { HOME_PATH } from '@/routes/home';

export function SignedOut() {
  return (
    <main style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}>
      <h1>Signed out</h1>
      <p>You have been signed out of Dink Admin.</p>
      <button type="button" onClick={() => redirectToCentralizedLogin(HOME_PATH)}>
        Sign in again
      </button>
    </main>
  );
}
